export default __webpack_public_path__ + "static/media/rosette.41e01467.svg";